<div class="poker-secure-popup">
  <div class="poker-secure-popup__modal"></div>
  <div class="secure-popup secure-popup__SMS">
    <div class="secure-head">
      <h3><img src="{{imagePath}}/img/secure/h1_sms.png" alt="보안 SMS"></h3>
      <a data-sms-click="cancel" href="#" class="secure-close"></a>
    </div>
    <div class="secure-body">
      <p class="sended-message">
        {{phoneNumber}}로 <br />
        인증번호가 발송되었습니다.
        <a data-sms-click="resend" href="#" class="secure-btn__retry">인증번호 재전송</a>
      </p>
      <div class="secure-input">
        <div class="number">
          <input data-sms-input type="text" class="secure-input__text" value="" maxlength="4">
          <span class="remaining-time">{{remainingTime}}</span>
        </div>
        <a href="{{unregisterLink}}" class="secure-btn__SMS-cancel">보안 SMS 해지</a>
        <a href="{{helpLink}}" class="secure-btn__SMS-1on1">1:1 문의하기</a>
      </div>
      <div class="foot-btns">
        <a data-sms-click="confirm" href="#" class="secure-btn__confirm-sms secure-btn--off">확인</a>
      </div>
    </div>
  </div>
</div>